var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "filter-form",
                  attrs: {
                    model: _vm.listPram,
                    size: "small",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "一级分类:" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "全部",
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    "remote-method": _vm.fetchCate1Options,
                                    loading: _vm.cate1Loading,
                                  },
                                  on: { change: _vm.onCate1Change },
                                  model: {
                                    value: _vm.listPram.cate1,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "cate1", $$v)
                                    },
                                    expression: "listPram.cate1",
                                  },
                                },
                                _vm._l(_vm.cate1Options, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "二级分类:" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "全部",
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    "remote-method": _vm.fetchCate2Options,
                                    disabled: !_vm.listPram.cate1,
                                    loading: _vm.cate2Loading,
                                  },
                                  on: { change: _vm.onCate2Change },
                                  model: {
                                    value: _vm.listPram.cate2,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "cate2", $$v)
                                    },
                                    expression: "listPram.cate2",
                                  },
                                },
                                _vm._l(_vm.cate2Options, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "三级分类:" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "全部",
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    disabled: !_vm.listPram.cate2,
                                    "remote-method": _vm.fetchCate3Options,
                                    loading: _vm.cate3Loading,
                                  },
                                  model: {
                                    value: _vm.listPram.cate3,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "cate3", $$v)
                                    },
                                    expression: "listPram.cate3",
                                  },
                                },
                                _vm._l(_vm.cate3Options, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "品牌名称:" } },
                            [
                              _c("el-input", {
                                staticClass: "selWidth",
                                attrs: {
                                  placeholder: "请输入品牌名称",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.listPram.brandName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listPram, "brandName", $$v)
                                  },
                                  expression: "listPram.brandName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "skuid:" } },
                            [
                              _c("el-input", {
                                staticClass: "selWidth",
                                attrs: {
                                  placeholder: "请输入skuid",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.listPram.skuid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listPram, "skuid", $$v)
                                  },
                                  expression: "listPram.skuid",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品名称:" } },
                            [
                              _c("el-input", {
                                staticClass: "selWidth",
                                attrs: {
                                  placeholder: "请输入商品名称",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.listPram.productName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listPram, "productName", $$v)
                                  },
                                  expression: "listPram.productName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "排列方式:" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: "",
                                    loading: _vm.sortLoading,
                                  },
                                  on: {
                                    "visible-change": _vm.onSortVisibleChange,
                                  },
                                  model: {
                                    value: _vm.listPram.sortType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "sortType", $$v)
                                    },
                                    expression: "listPram.sortType",
                                  },
                                },
                                _vm._l(_vm.sortOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态:" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: { placeholder: "全部", clearable: "" },
                                  model: {
                                    value: _vm.listPram.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "status", $$v)
                                    },
                                    expression: "listPram.status",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "全部", value: "" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "上架", value: "1" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "下架", value: "0" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handerSearch },
                                },
                                [_vm._v("搜索")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.handleReset },
                                },
                                [_vm._v("重置")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "warning",
                                    size: "small",
                                    loading: _vm.clearCacheLoading,
                                  },
                                  on: { click: _vm.handleClearCache },
                                },
                                [_vm._v("清除缓存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
                fit: true,
                "table-layout": "fixed",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "skuId",
                  label: "skuid",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "商品图片",
                  "min-width": "70",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.imagePath
                          ? _c("el-image", {
                              staticClass: "sku-thumb",
                              attrs: {
                                src: scope.row.imagePath,
                                "preview-src-list": [scope.row.imagePath],
                                fit: "cover",
                              },
                            })
                          : _c(
                              "div",
                              { staticClass: "sku-thumb placeholder" },
                              [_vm._v("--")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuName",
                  label: "商品名称",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "brandName",
                  label: "品牌",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "分类",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatCategory(scope.row)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "售价", "min-width": "90", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.salePrice != null
                          ? _c(
                              "span",
                              { class: _vm.getPriceClass(scope.row) },
                              [
                                _vm.getPriceDiff(scope.row) !== 0
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          placement: "top",
                                          enterable: false,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "price-tooltip",
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "售价：¥" +
                                                  _vm._s(scope.row.salePrice)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "山姆价：¥" +
                                                  _vm._s(scope.row.retail)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                style:
                                                  _vm.getPriceDiff(scope.row) >
                                                  0
                                                    ? "color:#f56c6c"
                                                    : "color:#67c23a",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.getPriceDiff(
                                                        scope.row
                                                      ) > 0
                                                        ? "上浮"
                                                        : "下浮"
                                                    ) +
                                                    "：\n                  " +
                                                    _vm._s(
                                                      _vm.getPriceDiff(
                                                        scope.row
                                                      ) > 0
                                                        ? "+"
                                                        : ""
                                                    ) +
                                                    _vm._s(
                                                      _vm.getAdjustRatio(
                                                        scope.row
                                                      )
                                                    ) +
                                                    "%\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            scope.row.singleAdjustRatio != null
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color: "#e6a23c",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  单商品调价：" +
                                                        _vm._s(
                                                          scope.row
                                                            .singleAdjustRatio >
                                                            0
                                                            ? "+"
                                                            : ""
                                                        ) +
                                                        _vm._s(
                                                          scope.row
                                                            .singleAdjustRatio
                                                        ) +
                                                        "%\n                "
                                                    ),
                                                  ]
                                                )
                                              : scope.row.categoryAdjustRatio !=
                                                null
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color: "#909399",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  分类调价：" +
                                                        _vm._s(
                                                          scope.row
                                                            .categoryAdjustRatio >
                                                            0
                                                            ? "+"
                                                            : ""
                                                        ) +
                                                        _vm._s(
                                                          scope.row
                                                            .categoryAdjustRatio
                                                        ) +
                                                        "%\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "price-wrap" },
                                          [
                                            _vm.getPriceDiff(scope.row) > 0
                                              ? _c(
                                                  "span",
                                                  { staticClass: "arrow" },
                                                  [_vm._v("↑")]
                                                )
                                              : _vm.getPriceDiff(scope.row) < 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "arrow down-arrow",
                                                  },
                                                  [_vm._v("↓")]
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                ¥" +
                                                _vm._s(scope.row.salePrice) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c("span", { staticClass: "price-wrap" }, [
                                      _vm.getPriceDiff(scope.row) > 0
                                        ? _c("span", { staticClass: "arrow" }, [
                                            _vm._v("↑"),
                                          ])
                                        : _vm.getPriceDiff(scope.row) < 0
                                        ? _c(
                                            "span",
                                            { staticClass: "arrow down-arrow" },
                                            [_vm._v("↓")]
                                          )
                                        : _vm._e(),
                                      _vm._v(
                                        "\n              ¥" +
                                          _vm._s(scope.row.salePrice) +
                                          "\n            "
                                      ),
                                    ]),
                              ],
                              1
                            )
                          : _c("span", { staticClass: "muted" }, [
                              _vm._v("--"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "结算价", "min-width": "80", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.sellPrice != null
                                ? "¥" + scope.row.sellPrice
                                : "--"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "山姆价", "min-width": "80", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.retail != null
                                ? "¥" + scope.row.retail
                                : "--"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "毛利率", "min-width": "70", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.grossMargin != null
                                ? scope.row.grossMargin + "%"
                                : "--"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "上下架状态", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "上架",
                            "inactive-text": "下架",
                          },
                          on: {
                            change: function (val) {
                              return _vm.handleListStatusChange(scope.row, val)
                            },
                          },
                          model: {
                            value: scope.row.listStatus,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "listStatus", $$v)
                            },
                            expression: "scope.row.listStatus",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "商品有效性",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatYn(scope.row.yn)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "是否手动调整上下架", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatManualAdjust(scope.row.manualAdjust)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "是否自营", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatSelfSellType(scope.row.selfSellType)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "配送类型", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatLogisticsType(scope.row.logisticsType)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "120", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openPriceAdjust(scope.row)
                              },
                            },
                          },
                          [_vm._v("调价")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openPriceRecord(scope.row)
                              },
                            },
                          },
                          [_vm._v("调价记录")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.pageLyp.limit,
              layout: _vm.constants.pageLyp.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("SamSkuDetail", { ref: "samSkuDetailRef" }),
      _vm._v(" "),
      _c("SamGoodsPriceAdjustDialog", {
        ref: "samGoodsPriceAdjustRef",
        on: { refresh: _vm.handlerGetListData },
      }),
      _vm._v(" "),
      _c("SamGoodsPriceRecordDialog", { ref: "samGoodsPriceRecordRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }